import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCopyToCb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 8L17 8C17.5523 8 18 8.44771 18 9L18 16C18 17.1046 17.1046 18 16 18L9 18C8.44772 18 8 17.5523 8 17L8 15M10 2L4 2C2.89543 2 2 2.89543 2 4L2 10C2 11.1046 2.89543 12 4 12L10 12C11.1046 12 12 11.1046 12 10L12 4C12 2.89543 11.1046 2 10 2Z"
      stroke="#4F5277"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
)
export default SvgCopyToCb
